export default __webpack_public_path__ + "static/media/gmail.cf54705a.svg";